import * as Sentry from '@sentry/react'
import App from './App'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorFallback } from './components/ErrorFallback'
import { isSessionExpiryNoise } from './utils/isSessionExpiryNoise'

Sentry.init({
  dsn: process.env.REACT_APP_GLITCHTIP_URL,
  environment: process.env.REACT_APP_GLITCHTIP_ENVIRONMENT ?? 'development',
  tracesSampleRate: 0.1,
  ignoreErrors: [
    "Failed to execute 'writeText' on 'Clipboard': Write permission denied.",
    'reCAPTCHA Timeout (b)',
  ],
  beforeSend(event) {
    if (isSessionExpiryNoise(event)) return null
    return event
  },
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)